const methods = {};
export const setServiceMethods = (serviceMethods) => {
  Object.keys(serviceMethods).forEach((method) => {
    methods[method] = serviceMethods[method];
  });
};
export default methods;
